<template>
  <div>
    <div class="mt-2 py-4 bg-gray-50 sm:mt-4 sm:pb-16 lg:mt-4 lg:pb-24">
      <div class="relative">
        <div class="relative z-10 max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
          <div
            class="max-w-md mx-auto lg:max-w-5xl lg:grid lg:grid-cols-3 lg:gap-5"
          >
            <div class="rounded-lg shadow-lg relative">
              <div
                v-if="recommendedPlan === 'free'"
                class="pointer-events-none absolute inset-0 rounded-lg border-2 border-teal-400"
              ></div>
              <div
                v-if="recommendedPlan === 'free'"
                class="absolute inset-x-0 top-0 transform translate-y-px"
              >
                <div class="flex justify-center transform -translate-y-1/2">
                  <span
                    class="inline-flex rounded-full bg-teal-400 px-4 py-1 text-sm leading-5 font-semibold tracking-wider uppercase text-white"
                  >
                    Recommended
                  </span>
                </div>
              </div>
              <div class="px-6 py-8 bg-white sm:p-10 sm:pb-6">
                <div>
                  <h3
                    class="inline-flex px-4 py-1 rounded-full text-sm leading-5 font-semibold tracking-wide uppercase bg-indigo-100 text-indigo-600"
                    id="tier-standard"
                  >
                    Free
                  </h3>
                </div>
                <div
                  class="mt-4 flex items-baseline text-6xl leading-none font-extrabold"
                >
                  $0
                  <span
                    class="ml-1 text-2xl leading-8 font-medium text-gray-500"
                  >
                    /mo
                  </span>
                </div>
              </div>
              <div class="px-6 pt-6 pb-8 bg-gray-50 sm:p-10 sm:pt-6">
                <ul>
                  <li class="flex items-start">
                    <div class="flex-shrink-0">
                      <svg
                        class="h-6 w-6 text-green-500"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                    </div>
                    <p class="ml-3 text-base leading-6 text-gray-700">
                      100 Manual WhatsApp messages.
                    </p>
                  </li>
                  <li class="mt-4 flex items-start">
                    <div class="flex-shrink-0">
                      <svg
                        class="h-6 w-6 text-green-500"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                    </div>
                    <p class="ml-3 text-base leading-6 text-gray-700">
                      Whatsapp share button
                    </p>
                  </li>
                  <li class="mt-4 flex items-start">
                    <div class="flex-shrink-0">
                      <svg
                        class="h-6 w-6 text-green-500"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                    </div>
                    <p class="ml-3 text-base leading-6 text-gray-700">
                      Whatsapp Chat button
                    </p>
                  </li>
                  <li class="mt-4 flex items-start">
                    <div class="flex-shrink-0">
                      <svg
                        class="h-6 w-6 text-green-500"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                    </div>
                    <p class="ml-3 text-base leading-6 text-gray-700">
                      Reports
                    </p>
                  </li>
                  <li class="mt-4 flex items-start">
                    <div class="flex-shrink-0">
                      <svg
                        class="h-6 w-6 text-green-500"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                    </div>
                    <p class="ml-3 text-base leading-6 text-gray-700">
                      Unlimited message templates
                    </p>
                  </li>
                  <li class="mt-4 flex items-start">
                    <div class="flex-shrink-0">
                      <svg
                        class="h-6 w-6 text-green-500"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                    </div>
                    <p class="ml-3 text-base leading-6 text-gray-700">
                      Standard support
                    </p>
                  </li>
                </ul>
                <div class="mt-6 rounded-md shadow">
                  <button
                    class="block w-full text-center rounded-lg bg-white px-6 py-3 text-base leading-6 font-semibold font-display text-teal-600 hover:text-teal-500 focus:outline-none focus:shadow-outline transition ease-in-out duration-150"
                    aria-describedby="tier-standard"
                    @click="choosePlan('free')"
                  >
                    Choose
                  </button>
                </div>
              </div>
            </div>
            <div class="mt-4 lg:mt-0 relative z-10 rounded-lg shadow-xl">
              <div
                v-if="recommendedPlan === 'vip'"
                class="pointer-events-none absolute inset-0 rounded-lg border-2 border-teal-400"
              ></div>
              <div
                v-if="recommendedPlan === 'vip'"
                class="absolute inset-x-0 top-0 transform translate-y-px"
              >
                <div class="flex justify-center transform -translate-y-1/2">
                  <span
                    class="inline-flex rounded-full bg-teal-400 px-4 py-1 text-sm leading-5 font-semibold tracking-wider uppercase text-white"
                  >
                    Recommended
                  </span>
                </div>
              </div>

              <div
                class="pointer-events-none absolute inset-0 rounded-lg"
              ></div>

              <div class="px-6 py-8 bg-white sm:p-10 sm:pb-6 rounded-t-lg">
                <div>
                  <h3
                    class="inline-flex px-4 py-1 rounded-full text-sm leading-5 font-semibold tracking-wide uppercase bg-indigo-100 text-indigo-600"
                    id="tier-enterprise"
                  >
                    VIP
                  </h3>
                </div>
                <div
                  class="mt-4 flex items-baseline text-6xl leading-none font-extrabold"
                >
                  $9.99
                  <span
                    class="ml-1 text-2xl leading-8 font-medium text-gray-500"
                  >
                    /mo
                  </span>
                </div>
              </div>
              <div class="px-6 pt-6 pb-8 bg-gray-50 sm:p-10 sm:pt-6">
                <ul>
                  <li class="flex items-start">
                    <div class="flex-shrink-0">
                      <svg
                        class="h-6 w-6 text-green-500"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                    </div>
                    <p class="ml-3 text-base leading-6 text-gray-700">Free +</p>
                  </li>
                  <li class="mt-4 flex items-start">
                    <div class="flex-shrink-0">
                      <svg
                        class="h-6 w-6 text-green-500"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                    </div>
                    <p class="ml-3 text-base leading-6 text-gray-700">
                      Unlimited Manual Messages
                    </p>
                  </li>
                  <li class="mt-4 flex items-start">
                    <div class="flex-shrink-0">
                      <svg
                        class="h-6 w-6 text-green-500"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                    </div>
                    <p class="ml-3 text-base leading-6 text-gray-700">
                      Automated messages
                      <a
                        class="text-blue-400 text-sm"
                        href="https://docs.google.com/spreadsheets/d/1g0BZDH4dhmaYmncEiTof-9iR1qnxf0Tp/edit?usp=sharing&ouid=107245128238572849936&rtpof=true&sd=true"
                        target="blank"
                        >(Price per message)</a
                      >
                    </p>
                  </li>
                  <li class="mt-4 flex items-start">
                    <div class="flex-shrink-0">
                      <svg
                        class="h-6 w-6 text-green-500"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                    </div>
                    <p class="ml-3 text-base leading-6 text-gray-700">
                      Whatsapp CRM
                    </p>
                  </li>
                  <li class="mt-4 flex items-start">
                    <div class="flex-shrink-0">
                      <svg
                        class="h-6 w-6 text-green-500"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                    </div>
                    <p class="ml-3 text-base leading-6 text-gray-700">
                      Email alerts
                    </p>
                  </li>
                  <li class="mt-4 flex items-start">
                    <div class="flex-shrink-0">
                      <svg
                        class="h-6 w-6 text-green-500"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                    </div>
                    <p class="ml-3 text-base leading-6 text-gray-700">
                      Priority support
                    </p>
                  </li>
                </ul>
                <div class="mt-6 rounded-md shadow">
                  <button
                    class="w-full flex items-center justify-center px-5 py-3 border border-transparent text-base leading-6 font-medium rounded-md text-white bg-gray-900 hover:bg-gray-800 focus:outline-none focus:shadow-outline transition duration-150 ease-in-out disabled:opacity-75"
                    aria-describedby="tier-enterprise"
                    @click="choosePlan('vip')"
                  >
                    <span>Start 7 day trial</span>
                  </button>
                </div>
              </div>
            </div>
            <div class="mt-4 lg:mt-0 relative z-10 rounded-lg shadow-xl">
              <div
                v-if="recommendedPlan === 'advanced'"
                class="pointer-events-none absolute inset-0 rounded-lg border-2 border-teal-400"
              ></div>
              <div
                v-if="recommendedPlan === 'advanced'"
                class="absolute inset-x-0 top-0 transform translate-y-px"
              >
                <div class="flex justify-center transform -translate-y-1/2">
                  <span
                    class="inline-flex rounded-full bg-teal-400 px-4 py-1 text-sm leading-5 font-semibold tracking-wider uppercase text-white"
                  >
                    Recommended
                  </span>
                </div>
              </div>
              <div class="px-6 py-8 bg-white sm:p-10 sm:pb-6 rounded-t-lg">
                <div>
                  <h3
                    class="inline-flex px-4 py-1 rounded-full text-sm leading-5 font-semibold tracking-wide uppercase bg-indigo-100 text-indigo-600"
                    id="tier-enterprise"
                  >
                    Advanced
                  </h3>
                </div>
                <div
                  class="mt-4 flex items-baseline text-6xl leading-none font-extrabold"
                >
                  $29
                  <span
                    class="ml-1 text-2xl leading-8 font-medium text-gray-500"
                  >
                    /mo
                  </span>
                </div>
              </div>
              <div class="px-6 pt-6 pb-8 bg-gray-50 sm:p-10 sm:pt-6">
                <ul>
                  <li class="flex items-start">
                    <div class="flex-shrink-0">
                      <svg
                        class="h-6 w-6 text-green-500"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                    </div>
                    <p class="ml-3 text-base leading-6 text-gray-700">VIP +</p>
                  </li>

                  <li class="mt-4 flex items-start">
                    <div class="flex-shrink-0">
                      <svg
                        class="h-6 w-6 text-green-500"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                    </div>
                    <p class="ml-3 text-base leading-6 text-gray-700">
                      Automated messages
                      <a
                        class="text-blue-400 text-sm"
                        href="https://docs.google.com/spreadsheets/d/1g0BZDH4dhmaYmncEiTof-9iR1qnxf0Tp/edit?usp=sharing&ouid=107245128238572849936&rtpof=true&sd=true"
                        target="blank"
                        >(Price per message)</a
                      >
                    </p>
                  </li>
                  <li class="mt-4 flex items-start">
                    <div class="flex-shrink-0">
                      <svg
                        class="h-6 w-6 text-green-500"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                    </div>
                    <p class="ml-3 text-base leading-6 text-gray-700">
                      Automation on own number
                    </p>
                  </li>
                  <li class="mt-4 flex items-start">
                    <div class="flex-shrink-0">
                      <svg
                        class="h-6 w-6 text-green-500"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                    </div>
                    <p class="ml-3 text-base leading-6 text-gray-700">
                      Custom automated templates
                    </p>
                  </li>

                  <li class="mt-4 flex items-start">
                    <div class="flex-shrink-0">
                      <svg
                        class="h-6 w-6 text-green-500"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                    </div>
                    <p class="ml-3 text-base leading-6 text-gray-700">
                      Priority support
                    </p>
                  </li>
                </ul>
                <div class="mt-6 rounded-md shadow">
                  <button
                    class="w-full flex items-center justify-center px-5 py-3 border border-transparent text-base leading-6 font-medium rounded-md text-white bg-gray-900 hover:bg-gray-800 focus:outline-none focus:shadow-outline transition duration-150 ease-in-out disabled:opacity-75"
                    aria-describedby="tier-enterprise"
                    @click="choosePlan('advanced')"
                  >
                    <span>Start 7 day trial</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <FreeAlertModal v-if="showAlert" @close="closeModal" />
  </div>
</template>

<script>
import FreeAlertModal from "./FreeAlertModal.vue";
export default {
  components: {
    FreeAlertModal
  },

  data() {
    return {
      recommendedPlan: "vip",
      showAlert: false,
      hasAlertedAlready: false
    };
  },
  created() {},

  methods: {
    choosePlan(plan) {
      if (plan === "free" && this.hasAlertedAlready === false) {
        this.showAlert = true;

        return;
      }
      if (plan === "free" && this.hasAlertedAlready) {
        this.$router.push({ name: "Home" });
        this.$store.dispatch("updateOnboardingCompletion");
        return;
      }
      this.$store.dispatch("updateOnboardingCompletion");
      this.$store
        .dispatch("selectPlan", { requestParams: { plan } })
        .then((response) => {
          if (response.confirmationUrl) {
            if (window.top) {
              window.top.location = response.confirmationUrl;
            } else {
              window.location.href = response.confirmationUrl;
            }
            return;
          }
          if (response.ok) {
            this.$router.push({ name: "Home" });
          }
        });
    },
    closeModal() {
      this.showAlert = false;
      this.hasAlertedAlready = true;
    }
  }
};
</script>

<style lang="scss" scoped></style>
